// @ts-ignore
import ImageTracer from 'imagetracerjs';

export interface VectorizeOptions {
  numberofcolors?: number;
  ltres?: number;
  qtres?: number;
  pathomit?: number;
}

export const vectorizeImage = (imageData: string, options: VectorizeOptions = {}): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      // Maximum quality for text and fine details
      const params = {
        ltres: options.ltres || 0.1,        // Maximum line accuracy
        qtres: options.qtres || 0.1,        // Maximum curve accuracy
        pathomit: options.pathomit || 1,    // Keep all small details
        numberofcolors: options.numberofcolors || 16,
        mincolorratio: 0,                   // Keep ALL colors
        colorquantcycles: 6,                // Maximum color accuracy
        scale: 1,
        strokewidth: 0,
        linefilter: false,                  // Keep all lines for maximum detail
        desc: false,
        viewbox: false,
        blurradius: 0,                      // No blur
        blurdelta: 20,
        rightangleenhance: true
      };

      ImageTracer.imageToSVG(imageData, (svgstr: string) => {
        resolve(svgstr);
      }, params);
    } catch (error) {
      reject(error);
    }
  });
};

export const posterizeImage = (imageData: string, options: any = {}): Promise<string> => {
  return vectorizeImage(imageData, {
    numberofcolors: options.steps || 20,  // More colors for better accuracy
    ltres: 0.1,
    qtres: 0.1,
    pathomit: 1
  });
};
